import * as yup from "yup";

import { getCurrencyCodeByLocale, LOCALES } from "~/constants/i18n";
import { getDisplayPrice } from "~/helpers/get-display-price";

const schema = yup.object({
  measureOfPrice: yup.number().required(),
  rawUnitOfMeasure: yup.string().required(),
  pricePerUnit: yup.number().required(),
});

// we can receive "gm" value that should be converted to "g"
// https://team-1626860771808.atlassian.net/l/cp/1HDfixa6
// For liters should be uppercase
// https://team-1626860771808.atlassian.net/browse/OSCWEB-28358

const createNormalizedUnitOfMeasure = (
  unitOfMeasure: string | undefined,
): string | undefined => {
  switch (unitOfMeasure) {
    case "gm":
      return "g";
    case "l":
      return "L";
    default:
      return unitOfMeasure;
  }
};

export const getProductPricePerUnitText = ({
  measureOfPrice,
  uomOfPrice: rawUnitOfMeasure,
  pricePerUnit,
  unitTranslation,
  locale,
}: {
  measureOfPrice?: number | null;
  uomOfPrice?: string | null;
  pricePerUnit: number;
  unitTranslation?: string;
  locale: LOCALES;
}): string | null => {
  try {
    schema.validateSync({ measureOfPrice, rawUnitOfMeasure, pricePerUnit });
  } catch (err) {
    return null;
  }

  // lower-cased because unit of measure can come in any case
  // https://team-1626860771808.atlassian.net/l/cp/1HDfixa6
  const lowerCasedUnitOfMeasure = rawUnitOfMeasure?.toLowerCase();

  const normalizedUnitOfMeasure = createNormalizedUnitOfMeasure(
    lowerCasedUnitOfMeasure,
  );

  if (normalizedUnitOfMeasure === "each" && !unitTranslation) {
    return null;
  }

  const productPrice = getDisplayPrice(
    locale,
    getCurrencyCodeByLocale(locale),
    pricePerUnit,
    true,
  );

  const measureOfPriceAndUnitOfMeasure = `${measureOfPrice !== 1 ? measureOfPrice : ""}${normalizedUnitOfMeasure}`;

  return `${productPrice}/${normalizedUnitOfMeasure === "each" ? unitTranslation : measureOfPriceAndUnitOfMeasure}`;
};
